// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fila[data-v-a5c888d4]{\n display: flex;\n flex-direction: row;\n justify-content: space-between;\n align-items: center;\n}\n.fila not[data-v-a5c888d4]:first-child{\n justify-content: end;\n}\n", ""]);
// Exports
module.exports = exports;
